export default __webpack_public_path__ + "static/media/images/dsaKeyset.713529f7.jpg";